import app from '../../forum/app';
import Component from '../../common/Component';
import DiscussionListItem from './DiscussionListItem';
import Button from '../../common/components/Button';
import LoadingIndicator from '../../common/components/LoadingIndicator';
import Placeholder from '../../common/components/Placeholder';
import classList from '../../common/utils/classList';

/**
 * The `DiscussionList` component displays a list of discussions.
 *
 * ### Attrs
 *
 * - `state` A DiscussionListState object that represents the discussion lists's state.
 */
export default class DiscussionList extends Component {
  oninit(vnode) {
    super.oninit(vnode);
    this.isAtBottom = false; // 初始化标志，用于标记是否滚动到底部
    this.scrollContainer = null; // 用于存储滚动容器的引用
    this.handleScroll = () => this.checkScrollBottom();
    window.addEventListener('scroll', this.handleScroll);
  }
  onremove(vnode) {
    // 当组件卸载时，移除事件监听器
    window.removeEventListener('scroll', this.handleScroll)
  }
  checkScrollBottom() {
    // 检查是否滚动到了底部
    const isAtBottom = window.innerHeight + window.scrollY >= document.documentElement.scrollHeight-50;
    
    if (isAtBottom && !this.isAtBottom) {
      this.isAtBottom = true;
        this.loadMoreComments();
    } else if (!isAtBottom && this.isAtBottom) {
      this.isAtBottom = false;
    }
  }
  loadMoreComments() {
    const state = this.attrs.state;
    state.loadNext()

  }
  view() {
    /**
     * @type {import('../states/DiscussionListState').default}
     */
    const state = this.attrs.state;
    const params = state.getParams();
    const isLoading = state.isInitialLoading() || state.isLoadingNext();

    let loading;

    if (isLoading) {
      loading = <LoadingIndicator />;
    } else if (state.hasNext()) {
      loading = (
        <Button className="Button" onclick={state.loadNext.bind(state)}>
          {app.translator.trans('core.forum.discussion_list.load_more_button')}
        </Button>
      );
    }

    if (state.isEmpty()) {
      const text = app.translator.trans('core.forum.discussion_list.empty_text');
      return (
        <div className="DiscussionList">
          <Placeholder text={text} />
        </div>
      );
    }
    const pageSize = state.pageSize;
    
    
    return (
      <div className={classList('DiscussionList', { 'DiscussionList--searchResults': state.isSearchResults() })}>
        <ul role="feed" aria-busy={isLoading} className="DiscussionList-discussions">
          {state.getPages().map((pg, pageNum) => {
              return pg.items
                .filter(discussion => {
                  
                  const currentUser = app.session.user; // 获取当前用户
                  return (discussion.isHidden() && discussion.user() === currentUser) || !discussion.isHidden();
                })
                .map((discussion, itemNum) => (
                  <li key={`${pageNum}-${itemNum}-${discussion.id()}`} data-id={discussion.id()} role="article" aria-setsize="-1" aria-posinset={pageNum * pageSize + itemNum}>
                    <DiscussionListItem discussion={discussion} params={params} />
                  </li>
                ));
            })}
        </ul>
        <div className="DiscussionList-loadMore">{loading}</div>
      </div>
    );
  }
}
